module.exports = "/_next/static/images/ca12aed0aec7f47d62912045145deab0-hero-variant-lg.png.webp";